import * as React from 'react';
import * as styles from './styles.css';

import { Header1, Paragraph1 } from '@cian/ui-kit';
import { useIsDesktop } from '@cian/valuation-utils-component';

import { AccordionRoot, AccordionItem } from '../../packages/Accordion';
import { content } from './content';
import { Wrapper } from '../Wrapper';

export const Faq: React.FC = () => {
  const isDesktop = useIsDesktop();

  return (
    <div className={styles['container']}>
      <Wrapper>
        <div className={styles['title']}>
          <Header1>Часто задаваемые вопросы</Header1>
        </div>
        <AccordionRoot isTwoColumn={isDesktop}>
          {content.map((item, index) => {
            return (
              <AccordionItem key={index} title={item.title}>
                <Paragraph1>{item.text}</Paragraph1>
              </AccordionItem>
            );
          })}
        </AccordionRoot>
      </Wrapper>
    </div>
  );
};

Faq.displayName = 'Faq';
